<template>
  <menu-layout-dynamic>
    <div class="container">
      <transition-group tag="div" class="menus">
        <div
          class="menu-container"
          v-for="menu in availableMenus"
          :key="menu.menuCode"
        >
          <menu-item
            :menu="menu"
            @click="moveToQuery(menu)"
            :size="menuItemSize"
          ></menu-item>
        </div>
      </transition-group>
    </div>
  </menu-layout-dynamic>
</template>

<script>
import woothee from 'woothee'
import MenuLayout from '@/components/layout/MenuLayout.vue'
import MenuItem from '@/components/MenuItem.vue'

const BROWSER = (woothee.parse(window.navigator.userAgent) || {}).name

export default {
  components: { MenuItem },
  name: 'app',
  data() {
    return {
      visibleMenuMode: 'all',
      windowHeight: 0,
      scrollElem: ['Edge'].includes(BROWSER)
        ? document.body
        : document.getElementsByTagName('html')[0],
    }
  },
  computed: {
    /**
     * ログインユーザーが閲覧可能なメニュー
     */
    availableMenus() {
      return this.$store.state.menus
    },
    menuItemSize() {
      const MAX_SIZE = 350
      const MIN_SIZE = 150

      const pageHeight = this.windowHeight
      const headerHeight = 104 // TODO どうやって取る？
      const footerHeight = 78 // TODO どうやって取る？

      let size = pageHeight - (headerHeight + footerHeight)

      if (size > MAX_SIZE) {
        size = MAX_SIZE
      } else if (size < MIN_SIZE) {
        size = MIN_SIZE
      }

      return size
    },
  },
  methods: {
    /**
     * 分析画面に遷移する
     *
     * 分析画面のパスは、`/query-${menu.menuCode}`のルール
     */
    moveToQuery(menu) {
      window.open(`${process.env.BASE_URL}query-${menu.menuCode}`)
    },
  },
  created() {
    this.$emit('update-layout', {
      component: MenuLayout,
    })

    this.windowHeight = window.innerHeight

    this.$windowResize.subscribe(windowSize => {
      this.windowHeight = windowSize.windowHeight
    })

    // マウスホイール操作を横スクロールに変換する
    window.addEventListener('wheel', e => {
      // ブラウザによってdeltaYの値が結構違うので、一回のホイールイベントで移動する
      // 量は固定にする
      const amount = e.deltaY > 0 ? 100 : -100
      this.scrollElem.scrollLeft += amount
    })
  },
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  width: 100%;
}

.menus {
  display: flex;
  justify-content: center;
  width: 100%;
}

.menu-container {
  margin-right: var(--spacing-medium);
}

// Menu transition animation
.menu-container {
  transition: all 0.5s;
}
.v-enter,
.v-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.v-leave-active {
  position: absolute;
}
</style>
